import { Directive, ElementRef, Input, OnChanges, OnDestroy, SimpleChanges, Renderer2, Output, EventEmitter } from '@angular/core';
import { GenericConfig, RestUrlsConfig } from '@signature-it/ngx-generic/config';

declare let _: any;
declare let $: any;

@Directive({
    selector: '[product-image]',
    standalone: false
})
export class ProductImageDirectiveGeneric implements OnChanges, OnDestroy {
    listenError: Function;
    protected _conf: object;
    protected _sizesList: string[] = ['Sma', 'Med', 'Big', 'Enlarge', 'Dim', 'DimTech', 'Tech2', 'Tech1'];
    protected _size: string;
    @Input('size') set size(size: string) {
        this._size = this._sizesList.indexOf(size) > -1 ? size : this._sizesList[0];
    }
    get size() {
        return !_.isEmpty(this._size) ? this._size : this._sizesList[0];
    }
    @Input() product: object; // TODO: create DTO
    @Output() srcChange = new EventEmitter();
    CDNPrefix = GenericConfig.CDNPrefix ? GenericConfig.CDNPrefix + '/' : '';

    constructor(protected restUrlsConf: RestUrlsConfig,
                protected el: ElementRef,
                protected renderer: Renderer2) {
        this._conf = GenericConfig;
    }

    ngOnChanges(changes: SimpleChanges): void {
        const imgEl = this.el.nativeElement;
        if (changes['product']) {
            const product = changes['product'].currentValue; // TODO: use DTO
            this.renderer.setAttribute(imgEl, 'alt', this.getProductName(product));
            const src = this.getProductPic(product);
            this.renderer.setAttribute(imgEl, 'loading', 'lazy');
            this.renderer.setAttribute(imgEl, 'src', src);
            this.listenError = this.renderer.listen(imgEl, 'error', this.onError.bind(event, this));
            this.srcChange.emit(src);
        }
    }

    onError(self, {target}) {
        if ($(target).attr('src') !== self.getNoImagePic()) {
            self.renderer.setAttribute(target, 'src', self.getNoImagePic());
        }
    }

    protected getProductPic(product: object): string {
        const path = `${this.CDNPrefix}${GenericConfig.productImagesPath}`;
        if(product['product_pic']) {
            return `${path}/${product['product_pic']}`;
        }
        if(product['ProductPic']) {
            return this._getProductPicPath(product['ProductPic'], this.size);
        } else {
            const pcode = this.getProductCode(product);
            return this._getFullProdPath(path, pcode, this.size);
        }
    }

    protected getProductCode(product: object) {
        return product['product_code'] || "";
    }

    protected getProductName(product: object) {
        return product['Name'] || "";
    }

    getNoImagePic() {
        let image = `${GenericConfig.noImagePic}`.replace(/{size}/, this.size);
        return `${this.CDNPrefix}${image}`;
    }

    ngOnDestroy() {
        if(this.listenError instanceof Function) {
            this.listenError();
        }
    }

    protected _getFullProdPath(path: string, pcode: string, size: string): string {
        return `${path}/${pcode}/${pcode}_${size}.jpg`;
    }

    protected _getProductPicPath(ProductPic: string, size: string): string {
        return `${this.CDNPrefix}${GenericConfig.imagesPath}/${ProductPic}_${size}.jpg`
    }
}
